import { Box, Button, Stack, Typography } from "@mui/material";
import ActionDialog from "../../../components/ActionDialog";
import LottieMeditation from "../../../assets/lottie/meditation.lottie";
import LottieVaccine from "../../../assets/lottie/vaccine.lottie";
import DotLotties from "../../../components/DotLotties";
import React from "react";
const ModalWelcome = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Function;
}) => {
  const [content, setContent] = React.useState({
    lottie: LottieVaccine,
    text: "",
  });
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const showProbability = 0.4;
    if (Math.random() < showProbability) {
      setOpen(true);
    }

    setTimeout(() => {
      setOpen(false);
    }, 3500);
  }, []);

  const ucapan = [
    "Mode sehat diaktifkan!",
    "Hi, Selamat berobat!",
    "Proses sembuh dimulai...",
    "Kirim semangat digital 📡",
    "Waktunya perbaikan tubuh!",
    "Pulih. Bahagia. Ulangi.",
    "Sembuh segera, oke?",
    "Kode sehat: ON ✅",
    "Mode healing: ON 🔋",
    "Recharge tubuh aktif ⚡",
    "Senyum = lebih cepat sembuh!",
    "Hi, Kamu kuat 💪",
    "Pemulihan dimulai... 🛠️",
    "Istirahat = Upgrade 💡",
    "Mari rehat sejenak 💆‍♂️",
    "Kami di sini untuk mendampingi setiap langkah Anda menuju kesembuhan.",
    "semangat dan senyum Anda, karena itu bagian dari terapi terbaik.",
    "Selamat datang di perjalanan sehat Anda 🌿",
    "Hari ini mulai, besok lebih baik.",
    "Misi sehat: Sedang berjalan 🚀",
    "Tubuhmu, rumahmu 🏠",
    "Sehat itu hadiah terbaik 🎁",
    "Pelan-pelan tapi pasti 💚",
    "Kesehatan: misi utama 💡",
  ];

  const animation = [LottieVaccine, LottieMeditation];

  React.useEffect(() => {
    if (open) {
      const ucapanAcak = ucapan[Math.floor(Math.random() * ucapan.length)];
      const animationAcak =
        animation[Math.floor(Math.random() * animation.length)];

      setContent({
        lottie: animationAcak,
        text: ucapanAcak,
      });
    }
    return () => {};
  }, [open]);

  return (
    <ActionDialog open={open} label="" setOpen={setOpen}>
      <Stack spacing={2}>
        <Box height="1vh"></Box>
        <DotLotties file={content.lottie} size="small" loop={true} />
        <Typography variant="body1" align="center">
          "{content.text}"
        </Typography>
        {/* <Button variant="contained" onClick={handleClose}>
          tutup
        </Button> */}
      </Stack>
    </ActionDialog>
  );
};

export default ModalWelcome;
